import { render, staticRenderFns } from "./ShopsOverall.vue?vue&type=template&id=7551f5c2&scoped=true&"
import script from "./ShopsOverall.vue?vue&type=script&lang=js&"
export * from "./ShopsOverall.vue?vue&type=script&lang=js&"
import style0 from "./ShopsOverall.vue?vue&type=style&index=0&id=7551f5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551f5c2",
  null
  
)

export default component.exports